import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class LoginResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImpvaG4uZG9lQGdtYWlsLmNvbSIsImV4cCI6MTcxOTM1NDcxM30.b6TKSVwzf1eFZqnIdzeMXD-g8suuJQhHjxTOFFKFDIc"
            }
        }
    }

    token() {
        return this.content().token;
    }
}